export const API_ENDPOINT: any = [];

export const ERROR_OBJECTS: Object = {
  required: '{{field}} es requerido',
  email: 'Porfavor ingrese un email valido'
};
